export const APPROVERS_CONFIGURATION_KEY = 'timesheets-approvers-mapping';
